import isValidEmail from '../utils/isValidEmail';
import parseJwt from '../utils/parseJwt';

const phoneNumberRegex = /^(\d){5,20}$/;

// Register Partner
window.validatePartnerForm = () => {
  const company_name_partner = document.forms.partner_form.company_name_partner.value;
  const contact_person_partner = document.forms.partner_form.contact_person_partner.value;
  const email_address_partner = document.forms.partner_form.email_address_partner.value;
  const tel_partner = document.forms.partner_form.tel_partner.value;
  let error = false;

  if (company_name_partner === null || company_name_partner == '') {
    $('#company_name_partner').addClass('form-control-error-dropdown');
    error = true;
  } else {
    $('#company_name_partner').removeClass('form-control-error-dropdown');
    $('#company_name_partner').addClass('form-control');
  }

  if (contact_person_partner === null || contact_person_partner == '') {
    $('#contact_person_partner').addClass('form-control-error-dropdown');
    error = true;
  } else {
    $('#contact_person_partner').removeClass('form-control-error-dropdown');
    $('#contact_person_partner').addClass('form-control');
  }

  if (email_address_partner === null || email_address_partner == '' || !isValidEmail(email_address_partner)) {
    $('#email_address_partner').addClass('form-control-error-dropdown');
    $('#error_email_partner').removeClass('form-control');
    $('#error_email_partner').removeClass('hidden');
    $('#error_email_partner').addClass('error-message');

    error = true;
  } else {
    $('#email_address_partner').removeClass('form-control-error-dropdown');
    $('#error_email_partner').addClass('form-control');
    $('#error_email_partner').addClass('hidden');
  }

  if (tel_partner === null || tel_partner == '' || !phoneNumberRegex.test(tel_partner)) {
    $('#tel_partner').addClass('form-control-error-dropdown');
    $('#error_tel_partner').removeClass('hidden');
    $('#error_tel_partner').addClass('error-message');
    error = true;
  } else {
    $('#tel_partner').removeClass('form-control-error-dropdown');
    $('#tel_partner').addClass('form-control');
    $('#error_tel_partner').addClass('hidden');
  }

  return !error;
};

// Register Customer Company check
window.customerCompany = () => {
  const company_name_company = document.forms.customer_company.company_name_company.value;
  const contact_person_company = document.forms.customer_company.contact_person_company.value;
  const email_address_company = document.forms.customer_company.email_address_company.value;
  const tel_company = document.forms.customer_company.tel_company.value;
  let error = false;

  if (company_name_company === null || company_name_company == '') {
    $('#company_name_company').addClass('form-control-error-dropdown');
    error = true;
  } else {
    $('#company_name_company').removeClass('form-control-error-dropdown');
    $('#company_name_company').addClass('form-control');
  }

  if (contact_person_company === null || contact_person_company == '') {
    $('#contact_person_company').addClass('form-control-error-dropdown');
    error = true;
  } else {
    $('#contact_person_company').removeClass('form-control-error-dropdown');
    $('#contact_person_company').addClass('form-control');
  }

  if (email_address_company === null || email_address_company == '' || !isValidEmail(email_address_company)) {
    $('#email_address_company').addClass('form-control-error-dropdown');
    $('#error_email_company').removeClass('form-control');
    $('#error_email_company').removeClass('hidden');
    $('#error_email_company').addClass('error-message');

    error = true;
  } else {
    $('#email_address_company').removeClass('form-control-error-dropdown');
    $('#error_email_company').addClass('form-control');
    $('#error_email_company').addClass('hidden');
  }

  if (tel_company === null || tel_company == '' || !phoneNumberRegex.test(tel_company)) {
    $('#tel_company').addClass('form-control-error-dropdown');
    $('#error_tel_company').removeClass('hidden');
    $('#error_tel_company').addClass('error-message');
    error = true;
  } else {
    $('#error_tel_company').addClass('hidden');
    $('#tel_company').removeClass('form-control-error-dropdown');
    $('#tel_company').addClass('form-control');
  }

  return !error;
};

// Register Customer Private check
window.validateCustomerPrivateForm = () => {
  const title = document.forms.user_type_customer_private.title.value;
  const first_name = document.forms.user_type_customer_private.first_name.value;
  const last_name = document.forms.user_type_customer_private.last_name.value;
  const email_address = document.forms.user_type_customer_private.email_address.value;
  const tel = document.forms.user_type_customer_private.tel.value;
  let error = false;

  if (title == 'title') {
    $('#title').addClass('form-control-error-dropdown');
    error = true;
  } else {
    $('#title').removeClass('form-control-error-dropdown');
    $('#title').addClass('form-control');
  }

  if (first_name === null || first_name == '') {
    $('#first_name').addClass('form-control-error-dropdown');
    error = true;
  } else {
    $('#first_name').removeClass('form-control-error-dropdown');
    $('#first_name').addClass('form-control');
  }

  if (last_name === null || last_name == '') {
    $('#last_name').addClass('form-control-error-dropdown');
    error = true;
  } else {
    $('#last_name').removeClass('form-control-error-dropdown');
    $('#last_name').addClass('form-control');
  }

  if (email_address === null || email_address == '' || !isValidEmail(email_address)) {
    $('#email_address').addClass('form-control-error-dropdown');
    $('#error_email').removeClass('form-control');
    $('#error_email').removeClass('hidden');
    $('#error_email').addClass('error-message');

    error = true;
  } else {
    $('#email_address').removeClass('form-control-error-dropdown');
    $('#error_email').addClass('form-control');
    $('#error_email').addClass('hidden');
  }

  if (tel === null || tel == '' || !phoneNumberRegex.test(tel)) {
    $('#tel').addClass('form-control-error-dropdown');
    $('#error_tel').removeClass('hidden');
    $('#error_tel').addClass('error-message');
    $('#selectlabel_customer').removeClass('error-message');
    $('#selectlabel_partner').removeClass('error-message');
    error = true;
  } else {
    $('#error_tel').addClass('hidden');
    $('#tel').removeClass('form-control-error-dropdown');
    $('#tel').addClass('form-control');
  }

  if (document.querySelector('#terms').checked) {
    $('#div_terms').removeClass('has-error');
  } else {
    $('#div_terms').addClass('has-error');
    error = true;
  }

  return !error;
};

// Show hidden div during registration proccess
window.showDiv = () => {
  $('#hidden').removeClass('hidden');
  $('#hidden').addClass('hidden_div');
  $('#selectlabel_customer').removeClass('error-message');
  $('#selectlabel_partner').removeClass('error-message');
};

// Hide div during registration proccess
window.hideDiv = () => {
  $('#hidden').addClass('hidden');
  $('#selectlabel_customer').removeClass('error-message');
  $('#selectlabel_partner').removeClass('error-message');
  $('#selectlabel_customer_private').removeClass('error-message');
  $('#selectlabel_customer_company').removeClass('error-message');

  $('#visible_customer').removeClass('hidden');
  $('#visible_customer').addClass('visible_customer');
  $('#hidden_customer').removeClass('radio m-b-15');
  $('#hidden_customer').addClass('hidden');
};

// Remove error-message if the right radio button is selected
window.removeError = () => {
  $('#selectlabel_customer_private').removeClass('error-message');
  $('#selectlabel_customer_company').removeClass('error-message');
  $('#selectlabel_customer').removeClass('error-message');
  $('#selectlabel_partner').removeClass('error-message');

  $('#visible_customer').removeClass('visible_customer');
  $('#visible_customer').addClass('hidden');
  $('#hidden_customer').removeClass('hidden');
  $('#hidden_customer').addClass('radio m-b-15');
};

window.callOptions = () => {
  // Get all elements with the name
  const buttons = $('input[name=\'user_type\']');
  const error = false;

  buttons.forEach((button) => {
    // Check if button is checked
    if (button.checked) {
      // Return value
      // If customer
      if (button.value == 'customer') {
        $('#selectlabel_customer_private').addClass('error-message');
        $('#selectlabel_customer_company').addClass('error-message');
        return error;
      }

      if (button.value == 'customer_private') {
        $('.lc-block').removeClass('toggled');
        $('#user_type_customer_private').addClass('toggled');

        return false;
      }

      if (button.value == 'customer_company1') {
        $('.lc-block').removeClass('toggled');
        $('#user_type_customer_company').addClass('toggled');

        return false;
      }

      if (button.value == 'partner') {
        $('.lc-block').removeClass('toggled');
        $('#user_type_partner').addClass('toggled');

        return false;
      }

      //  Of radio button has different value return button.value;
      $('#selectlabel_customer').addClass('error-message');
      $('#selectlabel_partner').addClass('error-message');
      $('#selectlabel_customer_private').addClass('error-message');
      $('#selectlabel_customer_company').addClass('error-message');
      return error;
    }
  });

  // If radio button is not selected
  $('#selectlabel_customer').addClass('error-message');
  $('#selectlabel_partner').addClass('error-message');
  $('#selectlabel_customer_private').addClass('error-message');
  $('#selectlabel_customer_company').addClass('error-message');
  return error;
};

$(document).ready(() => {
  /*
   * Login
   */
  if ($('.login-content')[0]) {
    // Add class to HTML. This is used to center align the login box
    $('html').addClass('login-content');

    // check if a window.locaation.hash is set
    const hashParams = new URLSearchParams(window.location.hash.slice(1));
    if (hashParams.has('forgot_password')) {
      $('.lc-block').removeClass('toggled');
      $('#l-forget-password').addClass('toggled');
    } else if (hashParams.has('forgot_password_wrong')) {
      $('.lc-block').removeClass('toggled');
      $('#forgot_password_wrong').addClass('toggled');
    } else if (hashParams.has('register')) {
      $('.lc-block').removeClass('toggled');
      $('#l-register').addClass('toggled');
    } else if (hashParams.has('verify')) {
      $('.lc-block').removeClass('toggled');
      $('#verify').addClass('toggled');
      const token = hashParams.get('token');
      $('#verify-token').val(token);
      const { uuid: userUuid } = parseJwt(token);
      window.safePasswordField.setUserUuid(userUuid);
    } else if (hashParams.has('verified')) {
      $('.lc-block').removeClass('toggled');
      $('#verified').addClass('toggled');
    } else if (hashParams.has('user_type_customer')) {
      $('.lc-block').removeClass('toggled');
      $('#user_type_customer').addClass('toggled');
    } else if (hashParams.has('user_type_customer_private')) {
      $('.lc-block').removeClass('toggled');
      $('#user_type_customer_private').addClass('toggled');
    } else if (hashParams.has('user_type_customer_company')) {
      $('.lc-block').removeClass('toggled');
      $('#user_type_customer_company').addClass('toggled');
    } else if (hashParams.has('user_type_partner')) {
      $('.lc-block').removeClass('toggled');
      $('#user_type_partner').addClass('toggled');
    } else if (hashParams.has('donep')) {
      $('.lc-block').removeClass('toggled');
      $('#donep').addClass('toggled');
    } else if (hashParams.has('donecp')) {
      $('.lc-block').removeClass('toggled');
      $('#donecp').addClass('toggled');
    } else if (hashParams.has('already_registered')) {
      $('.lc-block').removeClass('toggled');
      $('#already_registered').addClass('toggled');
    } else if (hashParams.has('email_send')) {
      $('.lc-block').removeClass('toggled');
      $('#email_send').addClass('toggled');
    } else if (hashParams.has('token_invalid')) {
      $('.lc-block').removeClass('toggled');
      $('#token_invalid').addClass('toggled');
    }

    $('body').on('click', '.login-navigation-left > li', function() {
      const z = $(this).data('block');
      const t = $(this).closest('.lc-block');

      t.removeClass('toggled');

      setTimeout(() => {
        $(z).addClass('toggled');
        window.location.hash = z === '#l-forget-password' ? '#forgot_password' : '';
      });
    });
    $('body').on('click', '.login-navigation-right > li', function() {
      const z = $(this).data('block');
      const t = $(this).closest('.lc-block');

      t.removeClass('toggled');

      setTimeout(() => {
        $(z).addClass('toggled');
        window.location.hash = '#register';
      });
    });
  }

  function deleteCookie(name) {
    document.cookie = `${name}=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
  }

  // clear token to get a new one
  deleteCookie('csrfToken');

  $('#verify-form').on('submit', async function(e) {
    e.preventDefault();
    const result = await window.safePasswordField.checkCurrentPassword();
    if (result) {
      this.submit();
    }
  });
});
